import { render, staticRenderFns } from "./aRmsStrategyWeeksDetailKpisPickupsRow.vue?vue&type=template&id=6a2b6bf8&scoped=true"
import script from "./aRmsStrategyWeeksDetailKpisPickupsRow.vue?vue&type=script&lang=js"
export * from "./aRmsStrategyWeeksDetailKpisPickupsRow.vue?vue&type=script&lang=js"
import style0 from "./aRmsStrategyWeeksDetailKpisPickupsRow.vue?vue&type=style&index=0&id=6a2b6bf8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a2b6bf8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAvatar,VBtn,VCol,VIcon,VRow,VSpacer})
